<script setup lang="ts">
withDefaults(defineProps<{
  disabled?: boolean
  selected?: boolean
}>(), {
  disabled: false,
  selected: false,
})
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    :class="[
      'group relative flex flex-col items-stretch w-full text-left rounded-card border-2 transition-colors',
      'focus-visible:outline-2 focus-visible:outline-brand-ink focus-visible:outline-offset-2',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      selected
        ? 'border-brand-ink bg-brand-yellow/15'
        : 'border-brand-ink/15 hover:border-brand-ink/40 hover:bg-brand-ink/[0.02]',
    ]"
  >
    <slot/>
  </button>
</template>
